import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Skeleton extends React.Component
{
    static propTypes = {
        className: PropTypes.string,
    };

    static defaultProps = {
        className: '',
    };

    render()
    {
        const classes = classNames(
            'animate-pulse bg-gray-200',
            this.props.className,
        );

        return <div {...this.props} className={classes} />;
    }
}
